import {
    Report,
    ReportStatus,
    ReportType
} from '@idea2app/ai-work-order-service';

import { TableModel } from './Base';
import userStore from './User';

export const ReportStatusLabels: Record<ReportStatus, string> = {
    in_progress: 'report_in_progress',
    queued: 'report_queued',
    completed: 'report_completed'
};

export const ReportStatusColors: Record<ReportStatus, string> = {
    in_progress: 'warning',
    queued: 'info',
    completed: 'success'
};

export const ReportTypeLabels: Record<ReportType, string> = {
    weekly: 'report_type_weekly',
    monthly: 'report_type_monthly',
    quarterly: 'report_type_quarterly',
    annual: 'report_type_yearly'
};

export class ReportModel extends TableModel<Report> {
    baseURI = 'report';
    client = userStore.client;
}

export default new ReportModel();
